import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterState, Sort, SortPropertyEnum } from "./types";

const initialState: FilterState = {
    searchValue: '',
    categoryId: 0,
    currentPage: 1,
    sort: {
      name: 'популярності',
      sortProperty: SortPropertyEnum.RATING_ASC,
    },
  };
  
  const filterSlices = createSlice({
    name: 'filters',
    initialState,
    reducers: { 
      setCategoryId (state, action: PayloadAction<number>) {
        state.categoryId =  action.payload;
      },
      setSearchValue (state, action: PayloadAction<string>) {
        state.searchValue =  action.payload;
      },
      setSort (state, action: PayloadAction<Sort>) {
        state.sort =  action.payload;
      },
      setCurrentPage (state, action: PayloadAction<number>) {
        state.currentPage = action.payload;
      },
      
      setFilters(state, action: PayloadAction<FilterState>) {
        if (Object.keys(action.payload).length) {
          state.currentPage = Number(action.payload.currentPage);
          state.categoryId = Number(action.payload.categoryId);
          state.sort = action.payload.sort;
        } else {
          state.currentPage = 1;
          state.categoryId = 0;
          state.sort = {
            name: 'популярности',
            sortProperty: SortPropertyEnum.RATING_DESC,
        };
      }
    },
    },
  });
  export const {setCategoryId, setSort, setCurrentPage, setFilters, setSearchValue} = filterSlices.actions;

export default filterSlices.reducer;